import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  border: 2px solid ${({ theme }) => theme.grey400};
  padding: 2rem 3rem;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-flow: column;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;

  @media only screen and (min-width: 1024px) {
    flex-flow: row;
    justify-content: space-between;
  }
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.primary500};

  font-family: ${({ theme }) => theme.fontHeader};
  font-size: 1.25rem;
  text-align: center;

  margin-left: -1.5px;

  @media only screen and (min-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const Description = styled.div`
  color: ${({ theme }) => theme.grey200};
  font-family: ${({ theme }) => theme.fontBody};
  font-size: 1.125rem;

  letter-spacing: 0.5px;
  line-height: 1.5rem;

  margin-bottom: 1rem;
`;
